/*
 * GTS "takaisin ylos" -nappi. Korvaa Scrolly / Custom Scroll To Top -appin
 * (app.getscrolly.com ja cstt-app.herokuapp.com tarjoilevat saman tiedoston,
 * tavu tavulta identtisen).
 *
 * Erot appiin, tarkoituksella:
 * - Markup tulee Liquidista ja on oikea <button>, eli se toimii nappaimistolla.
 *   Appin versio oli <svg role="button" onclick=...>, johon ei paase tabilla.
 * - Piilotus ostoskorin auettua kaytetaan teeman omia tapahtumia
 *   (theme:drawer:open / :close). Appin CSS odotti luokkaa .js-drawer-open,
 *   jota tama teema ei aseta koskaan, eli appin nappi jai korin paalle.
 * - prefers-reduced-motion: hyppy ylos ilman animaatiota.
 *
 * Sama kuin appissa: nappi ilmestyy kun on vieritetty yli 50 px, ja se kuuntelee
 * myos sisempien elementtien vieritysta capture-vaiheessa (scroll ei kupli).
 */
(function () {
  'use strict';

  var SHOW_AFTER = 50;

  function init() {
    var button = document.querySelector('[data-gts-to-top]');
    if (!button) return;

    var visible = false;
    var queued = false;
    var scroller = null; // elementti joka oikeasti vieritti, jos ei ikkuna

    function currentTop() {
      if (scroller) return scroller.scrollTop;
      return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    function apply() {
      var should = currentTop() > SHOW_AFTER;
      if (should === visible) return;
      visible = should;
      button.setAttribute('data-visible', should ? 'true' : 'false');
    }

    function onScroll(event) {
      var target = event && event.target;
      if (target && target !== document && target !== document.documentElement && target !== document.body) {
        scroller = target;
      } else {
        scroller = null;
      }
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        apply();
      });
    }

    button.addEventListener('click', function () {
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var target = scroller || window;
      if (target.scrollTo) {
        target.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
      } else {
        target.scrollTop = 0;
      }
      // Fokus takaisin sivun alkuun, jotta nappaimistokaytto ei jaa leijumaan.
      var first = document.querySelector('main, [role="main"], body');
      if (first && first.focus) {
        first.setAttribute('tabindex', '-1');
        first.focus({ preventScroll: true });
      }
    });

    // capture: true, koska scroll-tapahtumat eivat kupli
    document.addEventListener('scroll', onScroll, true);
    window.addEventListener('resize', onScroll, { passive: true });

    if (typeof window.on === 'function') {
      window.on('theme:drawer:open', function () {
        button.setAttribute('data-drawer', 'open');
      });
      window.on('theme:drawer:close', function () {
        button.removeAttribute('data-drawer');
      });
    }

    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
